import { configureStore } from "@reduxjs/toolkit";
import adminReducer, {
  selectPersistableAdminState,
} from "../features/admin/adminSlice";
import { persistAdminSnapshot } from "../features/admin/adminRepository";
import sessionReducer, {
  selectSessionSnapshot,
} from "../features/session/sessionSlice";
import { clearPersistedSession, persistSession } from "../features/session/sessionRepository";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    session: sessionReducer,
  },
});

let previousSnapshot = "";
let previousSessionSnapshot = "";

store.subscribe(() => {
  const rootState = store.getState();
  const state = rootState.admin;

  if (!state.hydrated) {
  } else {
    const persistableState = selectPersistableAdminState(rootState);
    const serialized = JSON.stringify(persistableState);

    if (serialized !== previousSnapshot) {
      previousSnapshot = serialized;
      persistAdminSnapshot(persistableState);
    }
  }

  const sessionSnapshot = selectSessionSnapshot(rootState);
  const serializedSession = JSON.stringify(sessionSnapshot);

  if (serializedSession === previousSessionSnapshot) {
    return;
  }

  previousSessionSnapshot = serializedSession;

  if (sessionSnapshot.isAuthenticated) {
    persistSession(sessionSnapshot);
    return;
  }

  clearPersistedSession();
});
